import { onValue, ref } from 'firebase/database';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useContext, useEffect, useState } from 'react';

export function useMatchDayResults({ currentSeason_info }) {

  const parentContext = useContext(ParentContext);

  const { states } = parentContext ?? {};
  const { app_state, paps_state } = states ?? {};
  const { pathViews } = paps_state ?? {};
  const { app_ts } = app_state ?? {};
  const { latestSeason } = currentSeason_info ?? {}

  const [matchDayResults, setMatchDayResults] = useState({});
  const [gsResults, setGsResults] = useState({});

  // const path_sport = `clients/${pathViews.clients}/events/${pathViews.events}/matchDayResults/${pathViews.sports}`;

  // const { data, loading } = useRtdbListener(
  //   app_ts?.realtime,
  //   app_ts?.app,
  //   path_sport,
  //   {
  //     initialValue: {},
  //     transform: (v) => v || {},
  //   }
  // );

  useEffect(() => {

    if (!app_ts?.realtime || !latestSeason || !pathViews?.sports) return;

    const path_matchDay = getPath_matchDayResultshPath(pathViews, latestSeason)
    const path_gs = getPath_gsResultsPath(pathViews, latestSeason)

    // const path_sport = `clients/${pathViews.clients}/events/${pathViews.events}/matchDayResults/${pathViews.sports}`;

    // console.log('path_sport', path_matchDay)
    // console.log('DB APP:', app_ts?.realtime);
    // console.log('adbp', '/clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/matchDayResults/2027')
    // /clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/matchDayResults/2027
    // /clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/matchDayResults/2027

    const _ref_matchDay = ref(app_ts.realtime, path_matchDay);

    onValue(
      _ref_matchDay,
      (snapshot) => {
        const mdrs = snapshot.val();

        console.log('⚡matchDayResults ⚡', mdrs);
        setMatchDayResults(mdrs);
      },
      (error) => {
        console.log('⚡matchDayResults error ⚡', error);
      }
    );

    const _ref_gs = ref(app_ts.realtime, path_gs);

    onValue(
      _ref_gs,
      (snapshot) => {
        const gsrs = snapshot.val();

        console.log('⚡gsResults ⚡', gsrs);
        setGsResults(gsrs);
      },
      (error) => {
        console.log('⚡matchDayResults error ⚡', error);
      }
    );

    // LIVE listener
    // onValue(_ref, handleValue);

    // cleanup
    // return () => {
    //   off(_ref, 'value', handleValue);
    // };

  }, [pathViews?.sports, latestSeason]);

  return { matchDayResults, gsResults };
}

const getPath_matchDayResultshPath = (pathViews, latestSeason) => {
  const path = `clients/${pathViews.clients}/events/${pathViews.events}/matchDayResults/${latestSeason}`
  return path
}

const getPath_gsResultsPath = (pathViews, latestSeason) => {
  const path = `clients/${pathViews.clients}/events/${pathViews.events}/gsResults/${latestSeason}`
  return path
}